import homeHero from 'images/map/landing/home-hero.jpg'
import kidsHero from 'images/map/landing/kids-1.jpg'
import chicagoVideo from 'images/map/video/chicago-video-button-image.png'
import educatorBanner from 'images/communities/Chicago/Educator/banner.jpg'

export const CATEGORY_OPTIONS = [
  'General Education',
  'Professional Development',
  'Skill Building',
  'Core Arts Disciplines',
  'Teaching Practice & Pedagogy',
  'Community & Youth Engagement',
  'Artist Development',
  'School & Organizational Training',
  'Equity, Access, Inclusion',
  'Technical Tools & Platforms',
]

export const DISCIPLINE_OPTIONS = [
  'Dance',
  'Literary Arts',
  'Media Arts',
  'Music',
  'Theatre',
  'Visual Arts',
]

export const COURSES = [
  {
    id: 1,
    title: 'Foundations of Drawing',
    category: 'Core Arts Disciplines',
    discipline: 'Visual Arts',
    instructor: 'Maya Thompson',
    description:
      'Build project-based units that connect technique and inquiry.',
    coverImage: homeHero,
  },
  {
    id: 2,
    title: 'Intro to Color Theory',
    category: 'Skill Building',
    discipline: 'Visual Arts',
    instructor: 'Jared Lin',
    description:
      'Use color relationships to strengthen visual composition and critique.',
    coverImage: kidsHero,
  },
  {
    id: 3,
    title: 'Water Color Painting',
    category: 'Core Arts Disciplines',
    discipline: 'Visual Arts',
    instructor: 'Sofia Ramirez',
    description:
      'Develop watercolor techniques for expressive classroom projects.',
    coverImage: chicagoVideo,
  },
  {
    id: 4,
    title: 'Digital Illustration 101',
    category: 'Technical Tools & Platforms',
    discipline: 'Media Arts',
    instructor: 'Leo Chen',
    description:
      'Learn beginner digital illustration workflows and tool fundamentals.',
    coverImage: educatorBanner,
  },
  {
    id: 5,
    title: 'Foundations of Ensemble Leadership',
    category: 'Skill Building',
    discipline: 'Music',
    instructor: 'Marcos Rivera',
    description:
      'Create rehearsal structures that improve collaboration and focus.',
    coverImage: homeHero,
  },
  {
    id: 6,
    title: 'Movement and Storytelling in the Classroom',
    category: 'Core Arts Disciplines',
    discipline: 'Dance',
    instructor: 'Naomi Chen',
    description: 'Use choreography prompts to strengthen narrative skills.',
    coverImage: kidsHero,
  },
  {
    id: 7,
    title: 'Intro to Digital Media Production',
    category: 'Technical Tools & Platforms',
    discipline: 'Media Arts',
    instructor: 'Andre Wells',
    description:
      'Plan and publish student media projects with simple workflows.',
    coverImage: chicagoVideo,
  },
  {
    id: 8,
    title: 'Facilitating Critique with Student Voice',
    category: 'Teaching Practice & Pedagogy',
    discipline: 'Visual Arts',
    instructor: 'Jasmine Patel',
    description: 'Run critique protocols that center reflection and growth.',
    coverImage: educatorBanner,
  },
  {
    id: 9,
    title: 'Directing Student-Devised Theatre',
    category: 'Core Arts Disciplines',
    discipline: 'Theatre',
    instructor: 'Leo Alvarez',
    description: 'Guide collaborative script development and performance.',
    coverImage: homeHero,
  },
  {
    id: 10,
    title: 'Integrating Poetry and Performance',
    category: 'General Education',
    discipline: 'Literary Arts',
    instructor: 'Avery Brooks',
    description: 'Blend spoken word and text study into engaging lessons.',
    coverImage: kidsHero,
  },
  {
    id: 11,
    title: 'Beginning Ballet Vocabulary',
    category: 'Core Arts Disciplines',
    discipline: 'Dance',
    instructor: 'Ari Simmons',
    description:
      'Introduce foundational dance vocabulary through movement games.',
    coverImage: homeHero,
  },
  {
    id: 12,
    title: 'Creative Movement for K-5',
    category: 'Teaching Practice & Pedagogy',
    discipline: 'Dance',
    instructor: 'Nina Flores',
    description:
      'Design age-appropriate creative movement lessons for early grades.',
    coverImage: kidsHero,
  },
  {
    id: 13,
    title: 'Spoken Word Workshop Design',
    category: 'Skill Building',
    discipline: 'Literary Arts',
    instructor: 'Mila Ortiz',
    description:
      'Plan spoken word workshop arcs that build confidence and craft.',
    coverImage: chicagoVideo,
  },
  {
    id: 14,
    title: 'Poetry Revision Studio',
    category: 'Professional Development',
    discipline: 'Literary Arts',
    instructor: 'Devon Reed',
    description:
      'Use revision routines that move students from draft to performance.',
    coverImage: educatorBanner,
  },
  {
    id: 15,
    title: 'Podcast Story Structure',
    category: 'Technical Tools & Platforms',
    discipline: 'Media Arts',
    instructor: 'Alex Kim',
    description:
      'Build engaging scripted and interview-based podcast episodes.',
    coverImage: homeHero,
  },
  {
    id: 16,
    title: 'Classroom Video Production',
    category: 'School & Organizational Training',
    discipline: 'Media Arts',
    instructor: 'Jordan Marks',
    description:
      'Develop repeatable production workflows for student video teams.',
    coverImage: kidsHero,
  },
  {
    id: 17,
    title: 'Choir Repertoire Planning',
    category: 'Core Arts Disciplines',
    discipline: 'Music',
    instructor: 'Taylor Brooks',
    description:
      'Sequence repertoire to support skill progression and confidence.',
    coverImage: chicagoVideo,
  },
  {
    id: 18,
    title: 'Beginning Music Theory',
    category: 'General Education',
    discipline: 'Music',
    instructor: 'Samira Cole',
    description:
      'Teach notation, rhythm, and harmony through practical exercises.',
    coverImage: educatorBanner,
  },
  {
    id: 19,
    title: 'Improvisation for Young Actors',
    category: 'Artist Development',
    discipline: 'Theatre',
    instructor: 'Kai Morgan',
    description:
      'Use improv routines to strengthen stage presence and collaboration.',
    coverImage: homeHero,
  },
  {
    id: 20,
    title: 'Scene Study Fundamentals',
    category: 'Skill Building',
    discipline: 'Theatre',
    instructor: 'Rae Patel',
    description:
      'Coach scene analysis and character work with actionable feedback.',
    coverImage: kidsHero,
  },
  {
    id: 21,
    title: 'Printmaking Basics',
    category: 'Core Arts Disciplines',
    discipline: 'Visual Arts',
    instructor: 'Avery Lin',
    description:
      'Explore safe, low-cost printmaking techniques for the classroom.',
    coverImage: chicagoVideo,
  },
  {
    id: 22,
    title: 'Portfolio Development Lab',
    category: 'Artist Development',
    discipline: 'Visual Arts',
    instructor: 'Noah Grant',
    description:
      'Guide students in curating and presenting cohesive art portfolios.',
    coverImage: educatorBanner,
  },
  {
    id: 23,
    title: 'Public Art and Community Voice',
    category: 'Community & Youth Engagement',
    discipline: 'Visual Arts',
    instructor: 'Harper Diaz',
    description:
      'Connect artmaking projects to local stories and civic themes.',
    coverImage: homeHero,
  },
  {
    id: 24,
    title: 'Design Thinking for Arts Classrooms',
    category: 'Equity, Access, Inclusion',
    discipline: 'Visual Arts',
    instructor: 'Parker Ellis',
    description:
      'Apply design thinking cycles to inclusive arts curriculum planning.',
    coverImage: kidsHero,
  },
]

const ATTEMPTS_KEY = 'learningHubCourseAttempts'

function readStorageJSON(key, fallback) {
  if (typeof window === 'undefined') return fallback

  try {
    const parsed = JSON.parse(window.localStorage.getItem(key))
    return parsed || fallback
  } catch (_error) {
    return fallback
  }
}

function writeStorageJSON(key, value) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(key, JSON.stringify(value))
}

export function getCourseAttempts() {
  return readStorageJSON(ATTEMPTS_KEY, {})
}

function defaultProgressPercent(courseId) {
  return 5 + ((Number(courseId) * 13) % 75)
}

function normalizeAttempt(raw) {
  if (!raw || typeof raw !== 'object') return null
  const status = raw.status === 'completed' ? 'completed' : 'in_progress'
  const progressPercent =
    typeof raw.progressPercent === 'number'
      ? Math.min(100, Math.max(0, raw.progressPercent))
      : status === 'completed'
      ? 100
      : defaultProgressPercent(raw.courseId)
  return {
    ...raw,
    courseId: Number(raw.courseId),
    status,
    progressPercent,
  }
}

export function createCourseAttempt(courseId) {
  const id = Number(courseId)
  const attempts = getCourseAttempts()
  const existing = attempts[id]
  if (existing) {
    return normalizeAttempt(existing)
  }
  const attempt = {
    courseId: id,
    status: 'in_progress',
    progressPercent: defaultProgressPercent(id),
    startedAt: new Date().toISOString(),
  }
  const nextAttempts = { ...attempts, [id]: attempt }
  writeStorageJSON(ATTEMPTS_KEY, nextAttempts)
  return attempt
}

export function updateCourseProgress(courseId, progressPercent) {
  const id = Number(courseId)
  const attempts = getCourseAttempts()
  const prev = attempts[id] || {
    courseId: id,
    startedAt: new Date().toISOString(),
    status: 'in_progress',
  }
  const pct = Math.min(100, Math.max(0, progressPercent))
  const completed = pct >= 100
  const nextAttempt = normalizeAttempt({
    ...prev,
    progressPercent: completed ? 100 : pct,
    status: completed ? 'completed' : 'in_progress',
    ...(completed ? { completedAt: new Date().toISOString() } : {}),
  })
  writeStorageJSON(ATTEMPTS_KEY, { ...attempts, [id]: nextAttempt })
  return nextAttempt
}

export function markCourseComplete(courseId) {
  const id = Number(courseId)
  const attempts = getCourseAttempts()
  const prev = attempts[id] || {
    courseId: id,
    startedAt: new Date().toISOString(),
    progressPercent: 100,
  }
  const nextAttempt = normalizeAttempt({
    ...prev,
    status: 'completed',
    progressPercent: 100,
    completedAt: new Date().toISOString(),
  })
  writeStorageJSON(ATTEMPTS_KEY, { ...attempts, [id]: nextAttempt })
  return nextAttempt
}

function byDateDesc(getDate) {
  return (a, b) => {
    const da = new Date(getDate(a) || 0).getTime()
    const db = new Date(getDate(b) || 0).getTime()
    return db - da
  }
}

export function getMyCoursesLists(coursesCatalog) {
  const catalog =
    coursesCatalog !== undefined && coursesCatalog !== null
      ? coursesCatalog
      : COURSES
  const attempts = getCourseAttempts()
  const active = []
  const completed = []

  Object.keys(attempts).forEach((key) => {
    const attempt = normalizeAttempt(attempts[key])
    if (!attempt) return
    const course = catalog.find(
      (c) => Number(c.id) === Number(attempt.courseId)
    )
    if (!course) return
    if (attempt.status === 'completed') {
      completed.push({ course, attempt })
    } else {
      active.push({ course, attempt })
    }
  })

  active.sort(byDateDesc((x) => x.attempt.startedAt))
  completed.sort(
    byDateDesc((x) => x.attempt.completedAt || x.attempt.startedAt)
  )

  return {
    active,
    completed,
    completedCount: completed.length,
    inProgressCount: active.length,
  }
}
